"use client";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BG6MEPCE.js";

// src/next/image/primitive.tsx
import Image from "next/image";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var r2URL_deprecated = `https://basehub.earth`;
var assetsURL = `https://assets.basehub.com`;
var basehubImageLoader = ({
  src,
  width,
  quality
}) => {
  let url;
  try {
    url = new URL(src);
  } catch (error) {
    throw new Error(`Invalid BaseHub Image URL: ${src}

Expected origin to be one of:
- ${r2URL_deprecated} (deprecated)
- ${assetsURL}
`);
  }
  const params = [`width=${width}`, `quality=${quality || 90}`];
  if (url.href.includes(r2URL_deprecated)) {
    if (url.pathname.startsWith("/cdn-cgi/image/")) {
      const [_empty, _cdnThing, _imageThing, currentParams = "", ...rest] = url.pathname.split("/");
      const filteredParams = currentParams.split(",").filter((param) => {
        return !param.startsWith("width=") && !param.startsWith("quality=") && !param.startsWith("w=") && !param.startsWith("q=") && // also strip height because next.js doesn't need it
        !param.startsWith("h=") && !param.startsWith("height=");
      });
      let newParams = [...filteredParams, ...params].join(",");
      if (newParams.includes("format=") === false) {
        newParams += ",format=auto";
      }
      url.pathname = `/cdn-cgi/image/${newParams}/${rest.join("/")}`;
    } else {
      params.push("format=auto");
      url.pathname = `/cdn-cgi/image/${params.join(",")}${url.pathname}`;
    }
  } else if (url.href.includes(assetsURL)) {
    params.forEach((param) => {
      const [key, value] = param.split("=");
      if (!key || !value)
        return;
      url.searchParams.set(key, value);
    });
    if (url.searchParams.has("format") === false) {
      url.searchParams.set("format", "auto");
    }
    url.searchParams.delete("height");
    url.searchParams.delete("h");
  }
  const imageURL = new URL(assetsURL);
  if (url.href.includes(r2URL_deprecated)) {
    if (url.pathname.startsWith("/cdn-cgi/image/")) {
      const [_empty, _cdnThing, _imageThing, currentParams = "", ...rest] = url.pathname.split("/");
      imageURL.pathname = rest.join("/");
      imageURL.search = currentParams.split(",").join("&");
    } else {
      imageURL.pathname = url.pathname;
      imageURL.search = url.search;
    }
  } else if (url.href.includes(assetsURL)) {
    imageURL.pathname = url.pathname;
    imageURL.search = url.search;
  } else {
    return src;
  }
  return imageURL.toString();
};
var BaseHubImage = forwardRef(
  (props, ref) => {
    var _a, _b, _c;
    
    const unoptimized = (_c = (_b = props.unoptimized) != null ? _b : (_a = props.src.toString().split("?")[0]) == null ? void 0 : _a.endsWith(".svg")) != null ? _c : void 0;
    return (
      // eslint-disable-next-line jsx-a11y/alt-text
      /* @__PURE__ */ jsx(
        Image,
        __spreadProps(__spreadValues({}, props), {
          placeholder: props.placeholder,
          loader: basehubImageLoader,
          unoptimized,
          ref
        })
      )
    );
  }
);
export {
  BaseHubImage,
  basehubImageLoader
};
